import _DialogActions from "@mui/material/DialogActions";
import _DialogTitle from "@mui/material/DialogTitle";
import _Dialog from "@mui/material/Dialog";
import _Phone from "@mui/icons-material/Phone";
import _Email from "@mui/icons-material/Email";
import _Button from "@mui/material/Button";
import _Public from "@mui/icons-material/Public";
import _DialogContent from "@mui/material/DialogContent";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import _Typography from "@mui/material/Typography";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { useSnackbar } from 'notistack';
import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import bicycleHomeLogo from '../assets/images/poi/accueil-velo.png';
import { useClipboard } from '../hooks';
export function PoiDialog({
  categories: _categories,
  poi,
  ...props
}) {
  const {
    t
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    copy: copyToClipboard
  } = useClipboard(() => enqueueSnackbar(t('commons.phone_copied_to_clipboard')), () => enqueueSnackbar(t('commons.failed_to_copy_phone_to_clipboard')));
  const photo = poi?.photos[0];
  const hasCategory = {};
  let categories = _categories.reduce((res, category) => {
    const {
      code,
      labelKey
    } = category;
    if (poi && labelKey && poi.categoryCodes.indexOf(code) > -1 && !hasCategory[labelKey]) {
      res.push(category);
      hasCategory[labelKey] = true;
    }
    return res;
  }, []);
  const description = poi?.description;
  let title = poi?.title;
  if (!title) {
    const category = categories[0];
    if (category && category.labelKey) {
      title = t(category.labelKey, {
        context: 'one'
      });
      categories = categories.slice(1);
    }
  }
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "md"
  }, props), photo && /*#__PURE__*/React.createElement(PhotoWrapper, {
    url: photo.thumbnailUrl || ''
  }), /*#__PURE__*/React.createElement(StyledDialogTitle, null, poi?.bicycleHome && /*#__PURE__*/React.createElement(StyledHeaderLogo, {
    title: "Accueil v\xE9lo",
    url: bicycleHomeLogo
  }), title, /*#__PURE__*/React.createElement(_Typography, {
    color: "textSecondary",
    component: "p",
    variant: "caption"
  }, categories.map(({
    id,
    labelKey
  }, index) => /*#__PURE__*/React.createElement(Fragment, {
    key: id
  }, index > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0\u2022\xA0"), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: labelKey,
    values: {
      context: 'one'
    }
  }))))), /*#__PURE__*/React.createElement(CloseButtonWrapper, null, /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "left",
    title: /*#__PURE__*/React.createElement(Trans, {
      i18nKey: "commons.actions.close"
    })
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => props.onClose(),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Close, null)))), categories.length > 0 && /*#__PURE__*/React.createElement(_DialogContent, null, /*#__PURE__*/React.createElement(_Typography, {
    component: "p",
    variant: "caption"
  }, description)), poi && (poi.website || poi.email || poi.phone) && /*#__PURE__*/React.createElement(StyledDialogActions, null, poi.website && /*#__PURE__*/React.createElement(_Button, {
    color: "primary",
    component: "a",
    href: poi.website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(_Public, null), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.website"
  })), poi.email && /*#__PURE__*/React.createElement(_Button, {
    color: "primary",
    component: "a",
    href: `mailto:${poi.email}`,
    size: "small"
  }, /*#__PURE__*/React.createElement(_Email, null), /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.email"
  })), poi.phone && /*#__PURE__*/React.createElement(_Button, {
    color: "primary",
    onClick: () => copyToClipboard(poi.phone || ''),
    size: "small"
  }, /*#__PURE__*/React.createElement(_Phone, null), poi.phone)));
}
const PhotoWrapper = styled.div`
  background-color: whitesmoke;
  background-image: ${({
  url
}) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 50%;
`;
const StyledDialogTitle = styled(_DialogTitle)`
  && {
    padding-right: 46px;

    h2 {
      align-items: center;
      display: flex;
    }
  }
`;
const StyledHeaderLogo = styled.div`
  align-self: center;
  background-image: ${({
  url
}) => `url(${url})`};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const CloseButtonWrapper = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;

  button {
    background-color: rgba(255, 255, 255, 0.8);

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
    }
  }
`;
const StyledDialogActions = styled(_DialogActions)`
  svg {
    margin-right: 4px;
  }
`;